import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { loadBanners, deleteBanner } from '../../actions/banner'
import { notificate } from '../../actions/notification'
import { links } from '../../utils'
import { Banner } from '../'
import { Spinner } from '../'

class BannersList extends Component {
  state = {
    filters: {
      limit: 10,
      page: 1
    }
  };

  componentDidMount () {
    this._loadData()
  };

  render () {
    const { sending, paging } = this.props.banner
    return (
      <div className="main-content">
        <Link className="button button--inline" to={links.get('addBanner')}>Novo banner</Link>
        {sending &&
          <div className="spinner-box">
            <Spinner />
          </div>
        }
        <div className="banner-list">
          {this._getBanners()}
        </div>
        {paging && paging.page &&
          <div className="pagination">
            <ReactPaginate
              pageCount={paging.pages}
              onPageChange={this._onPageChange}
              previousLabel='Anterior'
              nextLabel='Próxima'
            />
          </div>
        }
      </div>
    )
  };

  _loadData = () => {
    const { sending } = this.props.banner
    if (!sending) {
      this.props.loadBanners(this.state.filters, this.props.token)
    }
  }

  _getBanners = () => {
    const { list, sending } = this.props.banner
    if (sending) {
      return false
    }
    return list.map(item => {
      return (
        <Banner
          key={item.id}
          banner={item}
          onEdit={() => this._onEdit(item)}
          onDelete={() => this._onDelete(item)}
        />
      )
    })
  };

  _onDelete = item => {
    const { token } = this.props
    this.props.deleteBanner(item.id, token)
  };

  _onPageChange = item => {
    const filters = {
      ...this.state.filters,
      page: item.selected + 1
    }
    this.setState({ filters }, () => {
      this._loadData()
    })
  };
}

const mapStateToProps = (state) => {
  return {
    token: state.user.user.token,
    banner: state.banner
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadBanners: (filters, token) => dispatch(loadBanners(filters, token)),
    deleteBanner: (id, token) => dispatch(deleteBanner(id, token)),
    notificate: message => dispatch(notificate(message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BannersList)
